import BaseDropdownController from './base_dropdown_controller'
import {formatNumber, parseCleaveInput} from "../helpers/format-helper"

export default class extends BaseDropdownController {
  static targets = ["fromInput", "toInput", "applyBtn", "dropdownToggle", "countDisplay"]

  connect() {
    super.connect()
    this.initializeFromFormState()
    this.updateApplyButton()
    this.updateCountDisplay()
    this.element.addEventListener('keydown', this.handleKeydown.bind(this))
    
    // Listen for turbo frame loads to update display after form submissions
    document.addEventListener('turbo:frame-load', this.handleTurboFrameLoad.bind(this))
  }

  disconnect() {
    super.disconnect()
    this.element.removeEventListener('keydown', this.handleKeydown.bind(this))
    document.removeEventListener('turbo:frame-load', this.handleTurboFrameLoad.bind(this))
  }

  handleTurboFrameLoad(event) {
    // Update display when the auction results frame loads (after form submission)
    if (event.target.id === 'auction_results') {
      setTimeout(() => {
        this.updateCountDisplay()
      }, 50) // Small delay to ensure form is fully updated
    }
  }

  handleKeydown(event) {
    if (event.key === "Enter" && this.dropdownToggleTarget.getAttribute('aria-expanded') === 'true') {
      event.preventDefault()
      this.applyFilters()
    }
  }

  initializeFromFormState() {
    const form = document.getElementById('auction-filters-form')
    if (form) {
      const minSizeField = form.querySelector('[name="min_size"]')
      const maxSizeField = form.querySelector('[name="max_size"]')

      if (minSizeField && minSizeField.value) {
        this.fromInputTarget.value = minSizeField.value
      }

      if (maxSizeField && maxSizeField.value) {
        this.toInputTarget.value = maxSizeField.value
      }
    }
  }

  onInputChange(event) {
    this.updateApplyButton()
    this.updateCountDisplay()
  }

  onInputBlur(event) {
    this.validateSqmRange(event.target)
    this.updateApplyButton()
    this.updateCountDisplay()
  }


  validateSqmRange(changedInput) {
    const fromValue = parseCleaveInput(this.fromInputTarget.value) || 0
    const toValue = parseCleaveInput(this.toInputTarget.value) || 0

    if (fromValue < 0) {
      this.fromInputTarget.value = 0
    }
    if (toValue < 0) {
      this.toInputTarget.value = 0
    }

    if (!fromValue || !toValue) {
      return
    }

    if (fromValue > toValue) {
      if (changedInput === this.fromInputTarget) {
        this.toInputTarget.value = this.fromInputTarget.value
      } else if (changedInput === this.toInputTarget) {
        this.fromInputTarget.value = this.toInputTarget.value
      }
    }
  }

  applyFilters() {
    const focusedInput = document.activeElement
    if (focusedInput === this.fromInputTarget || focusedInput === this.toInputTarget) {
      this.validateSqmRange(focusedInput)
      this.updateApplyButton()
      this.updateCountDisplay()
    }

    this.syncWithFormFields()
    this.closeDropdown()
    this.closeOffcanvas()
    this.submitSharedForm()
  }

  syncWithFormFields() {
    const form = document.getElementById('auction-filters-form')
    if (form) {
      const minSizeField = form.querySelector('[name="min_size"]')
      const maxSizeField = form.querySelector('[name="max_size"]')

      if (minSizeField) {
        minSizeField.value = this.fromInputTarget.value
      }

      if (maxSizeField) {
        maxSizeField.value = this.toInputTarget.value
      }
    }
  }

  clearFilters() {
    this.fromInputTarget.value = ''
    this.toInputTarget.value = ''

    this.syncWithFormFields()
    this.updateApplyButton()
    this.updateCountDisplay()
    this.submitSharedForm()
  }

  updateApplyButton() {
    if (!this.hasApplyBtnTarget) return

    const fromValue = this.fromInputTarget.value.trim()
    const toValue = this.toInputTarget.value.trim()

    this.applyBtnTarget.disabled = fromValue === '' && toValue === ''
  }

  updateCountDisplay() {
    if (!this.hasCountDisplayTarget) return

    setTimeout(() => {
      // Get applied values from form fields instead of current input values
      const form = document.getElementById('auction-filters-form')
      let fromValue = null
      let toValue = null
      
      if (form) {
        const minSizeField = form.querySelector('[name="min_size"]')
        const maxSizeField = form.querySelector('[name="max_size"]')
        fromValue = minSizeField ? parseCleaveInput(minSizeField.value) : null
        toValue = maxSizeField ? parseCleaveInput(maxSizeField.value) : null
      }

      const hasRange = fromValue !== null || toValue !== null

      if (!hasRange) {
        this.countDisplayTarget.textContent = ""
      } else {
        let rangeText = ''
        if (fromValue && toValue) {
          rangeText = `(${formatNumber(fromValue)} - ${formatNumber(toValue)})`
        } else if (fromValue) {
          rangeText = `(≥ ${formatNumber(fromValue)})`
        } else if (toValue) {
          rangeText = `(≤ ${formatNumber(toValue)})`
        }
        this.countDisplayTarget.textContent = rangeText
      }

      if (this.hasDropdownToggleTarget) {
        if (!hasRange) {
          this.dropdownToggleTarget.classList.remove('filter-dropdown-active')
        } else {
          this.dropdownToggleTarget.classList.add('filter-dropdown-active')
        }
      }
    }, 0)
  }
}
